"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pino_1 = __importDefault(require("pino"));
function getLogger() {
    if (typeof window !== 'undefined') {
        return pino_1.default({ name: 'ambulizcore', browser: { asObject: true } });
    }
    else {
        let logEnabled = true;
        if (process.env.DISABLE_AMBULIZ_CORE_LOGS) {
            logEnabled = false;
        }
        return pino_1.default({
            name: 'ambulizcore',
            level: 'error',
            enabled: logEnabled,
            prettyPrint: {
                forceColor: true,
            },
        });
    }
}
const Logger = getLogger();
function error(mergingObject, message, ...interpolationValues) {
    Logger.error(mergingObject, message, ...interpolationValues);
}
exports.default = {
    info: Logger.info.bind(Logger),
    warn: Logger.warn.bind(Logger),
    debug: Logger.debug.bind(Logger),
    error: error,
    trace: Logger.trace.bind(Logger),
    fatal: Logger.fatal.bind(Logger),
};
//# sourceMappingURL=Logger.js.map